import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PromptSet } from '../../shared/api.service';
import { ExportService } from '../../shared/export.service';

export interface ExportPreviewDialogData {
    promptSets: PromptSet[];
    mode: 'all' | 'selected';
}

@Component({
    selector: 'app-export-preview-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule
    ],
    templateUrl: './export-preview-dialog.component.html',
    styleUrl: './export-preview-dialog.component.scss'
})
export class ExportPreviewDialogComponent {
    isExporting = false;
    exportComplete = false;
    exportError = false;

    // Computed stats
    totalPromptSets: number;
    totalPrompts: number;
    setsWithOutputSchema: number;
    setsWithSummaryPrompt: number;
    publishedSets: number;

    constructor(
        private dialogRef: MatDialogRef<ExportPreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ExportPreviewDialogData,
        private exportService: ExportService
    ) {
        const sets = data.promptSets;
        this.totalPromptSets = sets.length;
        this.totalPrompts = sets.reduce((sum, s) => sum + (s.prompts?.length || 0), 0);
        this.setsWithOutputSchema = sets.filter(s => {
            const schema = (s as any).outputSchema || (s as any).output_schema;
            return schema?.fields && schema.fields.length > 0;
        }).length;
        // Summary prompt existence can't be known without API calls, so we show "will be checked"
        this.setsWithSummaryPrompt = -1; // -1 signals unknown
        this.publishedSets = sets.filter(s => s.published).length;
    }

    async startExport(): Promise<void> {
        this.isExporting = true;
        this.exportError = false;

        try {
            if (this.data.mode === 'all') {
                await this.exportService.exportPromptSetsToExcel(this.data.promptSets);
            } else {
                await this.exportService.exportSinglePromptSetToExcel(this.data.promptSets[0]);
            }
            this.exportComplete = true;
        } catch (error) {
            console.error('Export failed:', error);
            this.exportError = true;
        } finally {
            this.isExporting = false;
        }
    }

    close(): void {
        this.dialogRef.close(this.exportComplete);
    }
}
